module.exports = __webpack_public_path__ + "static/media/walking-tiger-nobg.f8b577ae.jpeg";